module.exports = __webpack_public_path__ + "img/bigpack-inactive.e323ad8f.svg";